export const NAME = 'file-uploader';

export const ACCEPTED_FILES =
    'image/png,image/jpeg,image/jpg,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/zip,application/x-zip-compressed,application/x-rar-compressed';
